<template>
  <!--  <Navigation />-->
  <div id="container">
    <div class="toolbar">
      <template v-if="$route.name != 'Login'">
        <div>Ingelogd als {{ SimpleStore.username }}</div>
        <router-link :to="{ name: 'Login'}">Uitloggen</router-link>
      </template>
    </div>

    <router-view v-slot="{Component}">
      <transition name="fade" mode="out-in">
        <component :is="Component" :key="$route.path"></component>
      </transition>
    </router-view>

  </div>
</template>

<script>
import {SimpleStore} from "./simplestore";

export default {
  data() {
    return {
      SimpleStore
    }
  },

};
</script>

<style>

</style>